const ua = navigator.userAgent
/** 判断是否恒驰IOS App环境 */
export function isHCIOSApp() {
  return /hengchi_ios/.test(ua)
}

/** 判断是否恒驰Android App环境 */
export function isHCAndroidApp() {
  return /hengchi_android/.test(ua)
}

/** 判断是否恒驰App环境 */
export function isHCApp() {
  return /hengchi_/.test(ua)
}